import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { OnBaseCatalogueType, ParamPhoneMaskHn } from 'src/app/@core/constants';
import { InputUtils } from 'src/app/@core/utils/input-utils';
import { Param } from 'src/app/models/param';
import { CustomerUpdateContact } from 'src/app/models/request/CustomerUpdateContact';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ParamsService } from 'src/app/services/params.service';

@Component({
  selector: 'app-contact-payment-modal',
  templateUrl: './add-contact-modal.component.html',
  styleUrls: ['./add-contact-modal.component.sass']
})
export class AddContactModalComponent implements OnInit {

  confirmAction: (customerUpdateContact: CustomerUpdateContact) => any = () => { };
  add: (customerUpdateContact: CustomerUpdateContact) => any = () => { };

  formContact: FormGroup = this.fb.group({});
  countryResidenceMinLength: number = 9;
  phoneMask: string = "";
  naturalRelationList: Array<Param> = new Array<Param>();

  constructor(private bsModalRef: BsModalRef, private fb: FormBuilder, private paramsService: ParamsService, private onbaseService: OnbaseService) {



    this.formContact = this.fb.group({
      firstName: ['', Validators.required],
      middleName: [''],
      firstLastName: ['', Validators.required],
      secondLastName: [''],
      matiralStatus: [''],
      email: ['', [Validators.email]],
      phone: ['', [Validators.required, Validators.minLength(this.countryResidenceMinLength)]],
      phoneResidence: ['', [Validators.minLength(this.countryResidenceMinLength)]],
      workPhoneNumber: ['', [Validators.minLength(this.countryResidenceMinLength)]],
      phoneResidenceExtension: [''],
      naturalRelation: [Validators.required]
    });
  }

  async ngOnInit(): Promise<void> {
    this.naturalRelationList = (await this.onbaseService.readOnBaseCatalogueObject(OnBaseCatalogueType.NATURALRELATION, undefined).toPromise());
    let params: any = (await this.paramsService.readParams().toPromise()).response;
    this.phoneMask = params[ParamPhoneMaskHn];
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  onlyNumbers(event: any): boolean {

    return InputUtils.onlyNumbers(event);
  }

  public mapResponse(): CustomerUpdateContact {
    let contact: CustomerUpdateContact = new CustomerUpdateContact();
    contact.firstName = this.formContact.get('firstName')?.value;
    contact.middleName = this.formContact.get('middleName')?.value;
    contact.firstLastName = this.formContact.get('firstLastName')?.value;
    contact.secondLastName = this.formContact.get('secondLastName')?.value;
    contact.mobilePhone = this.formContact.get('phone')?.value;
    contact.homePhone = this.formContact.get('phoneResidence')?.value;
    contact.workPhoneNumber = this.formContact.get('workPhoneNumber')?.value;
    contact.extension = this.formContact.get('phoneResidenceExtension')?.value;
    contact.email = this.formContact.get('email')?.value;

    if (this.formContact.get('naturalRelation')?.value != undefined)
      contact.tipoRelacion = this.naturalRelationList.find(x => x.code == this.formContact.get('naturalRelation')?.value)?.value!;

    return contact;
  }

  addContact() {
    this.confirmAction(this.mapResponse());
    this.bsModalRef.hide();
  }
}
